export function App() {
  return (
    <div>
      <h1>Welcome to Acme Frontend</h1>
    </div>
  )
}
